import { formatCurrency, SupportedCurrency } from "creso-core/utils";
import { useMemo } from "react";

interface Props {
  type?: "rupees";
  format?: boolean;
  children: string | number;
  precision?: number;
  currency?: SupportedCurrency;
}

export default function Amount(props: Props) {
  const { children: amount } = props;

  const formattedAmount: string = useMemo(
    () =>
      formatCurrency(amount, props.currency, {
        precision: props.precision ?? 2,
        trim: !!props.format,
      }),
    [amount, props.currency, props.precision, props.format]
  );

  return <>{formattedAmount}</>;
}
